import { Alert } from "DesignSystem/components"
import { ChatInterface } from "Shared/components/ChatInterface/ChatInterface"
import { useChatWebhook } from "Shared/components/ChatInterface/useChatWebhook"
import React from "react"
import { ModeratedStudyApplicationFlow } from "~/api/generated/usabilityhubResponses"

type Props = {
  moderatedStudyApplicationFlow: ModeratedStudyApplicationFlow
}

export const PanelistChatInterface: React.FC<Props> = ({
  moderatedStudyApplicationFlow,
}) => {
  const { status, messages, sendMessage, markAsRead } = useChatWebhook(
    "PanelistModeratedStudyChatChannel",
    moderatedStudyApplicationFlow.moderated_study_application_id
  )

  const isBookingComplete = ["complete", "auto_complete"].includes(
    moderatedStudyApplicationFlow.booking?.state ?? ""
  )

  const helpMessage = isBookingComplete
    ? "This session has been marked as completed, you can no longer message the host."
    : undefined

  return (
    <>
      {status === "disconnected" && (
        <Alert
          status="danger"
          description="The chat connection has been lost. Please try refreshing the page."
          mt={4}
        />
      )}
      <ChatInterface
        isLoading={status === "loading"}
        messages={messages}
        sendMessage={sendMessage}
        onRead={markAsRead}
        emptyMessage="No message history with host"
        perspective="panelist"
        helpMessage={helpMessage}
        isReadOnly={status === "disconnected" || isBookingComplete}
      />
    </>
  )
}
